import React, { useState } from 'react';
import { HeaderMd } from '@/card/components/header-md';
import { ChartInKpiCard } from '@/chart/components/chart-in-kpi-card';
import { datasetTypes } from '@/constants';
import styled from 'styled-components';
import * as Card from './card';
import { KPIRibbon } from './kpi-ribbon';

export const ChartWrapper = styled.div`
  height: 300px; /* hardcoded now bc the only chart using this is not responsive */
  margin-top: 21px;
`;

/**
 * Card used for displaying performance indicators about a dataset
 */
export function KPICard({ data, onClickHandlers, optionsOverride }) {
  const [currentTab, setCurrentTab] = useState(
    datasetTypes.CURRENT_STR_PROPERTIES
  );
  return (
    <Card.Lg>
      <HeaderMd
        onClickHandlers={onClickHandlers}
        optionsOverride={optionsOverride}
      />
      <KPIRibbon
        kpiData={data.latestKpi}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
      />
      <ChartWrapper data-cy="chart-wrapper">
        <ChartInKpiCard
          currentChartType={currentTab}
          kpiData={data.latestKpi}
        />
      </ChartWrapper>
    </Card.Lg>
  );
}
